// extracted by mini-css-extract-plugin
module.exports = {"grid":"SubmitLeveler_grid__IwgTe","submit":"SubmitLeveler_submit__rI5sy"};